import React, { useState, useEffect } from 'react';
import { Col, Nav, Row, Tab, Tabs } from 'react-bootstrap';
import ServingCategoriesDonutFull from '../../ChartsImpl/DetailsPageCharts/ServingCategoriesDonutFull';
import OperatorStatusCountChart from '../../ChartsImpl/DetailsPageCharts/OperatorStatusCountChart';
import { ShimmerThumbnail, ShimmerCircularImage, ShimmerTitle } from "react-shimmer-effects";
import GuageChart from '../../ChartsImpl/DetailsPageCharts/GuageChart';
import axios from 'axios';
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import OperatorStatusCount from '../../ChartsImpl/DetailsPageCharts/OperatorStatusCount';
import { data } from 'jquery';
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import Tooltip from '@mui/material/Tooltip';

const OperatorStatusDetails = ({ showOperatorStatusDetails, setShowOperatorStatusDetails, selectedBranchLevel,
    selectedBranchId, operatorLoginInc, messageInc9998, messageInc9999, messageInc1001, messageInc1002, messageInc2000, messageInc2001,
    messageInc3000, messageInc3001, date, setSticky }) => {

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');

    const [allDataLoaded, setAllDataLoaded] = useState(false);

    const [operatorsList, setOperatorsList] = useState([]);
    const [operatorDetails, setOperatorDetails] = useState({});
    const [selectedUser, setSelectedUser] = useState(null);
    const [userLoginStatus, setuserLoginStatus] = useState(0)
    const [initialOperatorsList, setInitialOperatorsList] = useState([])
    const [searchKeyword, setSearchKeyword] = useState(null)
    const [exeption, setExeption] = useState(false)

    const [chartValue, setChartValue] = useState(0)

    const [categories, setCategories] = useState([])
    const [ratio, setRatio] = useState('')
    const [percentages, setPercentages] = useState([])
    const [searchtext, setSearchText] = useState('')

    const [hourInt, setHourInt] = useState([])
    const [ticketCount, setTicketCount] = useState([])

    const [filterStatus, setFilterStatus] = useState(null);
    const [filterOnlineUsers, setFilterOnlineUsers] = useState([]);
    const [filterOfflineUsers, setFilterOfflineUsers] = useState([]);

    const [update, setUpdate] = useState('1s')

    const [showHoverModal, setShowHoverModal] = useState(false);

    // Call getAllOperatorsLoggedInBranch according to operatorLoginInc.
    useEffect(() => {

        if (showOperatorStatusDetails === false) return;
        if (operatorLoginInc > 0) {
            getAllOperatorsLoggedInBranch();
        }

    }, [operatorLoginInc]);

    useEffect(() => {

        const interval = setInterval(() => {
            if (operatorDetails !== null) {
                // const element = operatorDetails[index];
                if (userLoginStatus === 1) {
                    operatorDetails.serviceTimeToSec = operatorDetails.serviceTimeToSec + 5;
                    // alert("2 - service")
                    if (operatorDetails.servingTimeToSec > operatorDetails.servingTimeKpiToSec) {
                        setExeption(true);
                    }
                    let serviceTimeHours = Math.floor(operatorDetails.serviceTimeToSec / 3600);
                    let serviceTimeMinutes = Math.floor((operatorDetails.serviceTimeToSec - (serviceTimeHours * 3600)) / 60);
                    let serviceTimeSeconds = operatorDetails.serviceTimeToSec - (serviceTimeHours * 3600) - (serviceTimeMinutes * 60);

                    if (serviceTimeHours < 10) {
                        serviceTimeHours = "0" + serviceTimeHours;
                    }
                    if (serviceTimeMinutes < 10) {
                        serviceTimeMinutes = "0" + serviceTimeMinutes;
                    }
                    if (serviceTimeSeconds < 10) {
                        serviceTimeSeconds = "0" + serviceTimeSeconds;
                    }

                    operatorDetails.serviceTime = `${serviceTimeHours}:${serviceTimeMinutes}:${serviceTimeSeconds}`;

                    operatorDetails.servingTimeToSec = operatorDetails.servingTimeToSec + 5;
                    // alert("2 - service")
                    let servingTimeHours = Math.floor(operatorDetails.servingTimeToSec / 3600);
                    let servingTimeMinutes = Math.floor((operatorDetails.servingTimeToSec - (servingTimeHours * 3600)) / 60);
                    let servingTimeSeconds = operatorDetails.servingTimeToSec - (servingTimeHours * 3600) - (servingTimeMinutes * 60);

                    if (servingTimeHours < 10) {
                        servingTimeHours = "0" + servingTimeHours;
                    }
                    if (servingTimeMinutes < 10) {
                        servingTimeMinutes = "0" + servingTimeMinutes;
                    }
                    if (servingTimeSeconds < 10) {
                        servingTimeSeconds = "0" + servingTimeSeconds;
                    }

                    operatorDetails.servingTime = `${servingTimeHours}:${servingTimeMinutes}:${servingTimeSeconds}`;

                    setOperatorDetails(operatorDetails);
                    setUpdate(new Date().toString());
                }

                if (userLoginStatus === 0) {
                    operatorDetails.idleTimeToSec = operatorDetails.idleTimeToSec + 5;

                    // alert("2 - idle")
                    let idleTimeHours = Math.floor(operatorDetails.idleTimeToSec / 3600);
                    let idleTimeMinutes = Math.floor((operatorDetails.idleTimeToSec - (idleTimeHours * 3600)) / 60);
                    let idleTimeSeconds = operatorDetails.idleTimeToSec - (idleTimeHours * 3600) - (idleTimeMinutes * 60);

                    if (idleTimeHours < 10) {
                        idleTimeHours = "0" + idleTimeHours;
                    }
                    if (idleTimeMinutes < 10) {
                        idleTimeMinutes = "0" + idleTimeMinutes;
                    }
                    if (idleTimeSeconds < 10) {
                        idleTimeSeconds = "0" + idleTimeSeconds;
                    }

                    operatorDetails.idleTime = `${idleTimeHours}:${idleTimeMinutes}:${idleTimeSeconds}`;

                    setOperatorDetails(operatorDetails);
                    setUpdate(new Date().toString());
                }

                if (userLoginStatus === 3) {

                    if (operatorDetails.auxModeTimeToSec !== null) {
                        operatorDetails.auxModeTimeToSec = operatorDetails.auxModeTimeToSec + 5;

                        // alert(operatorDetails.auxModeTimeToSec)

                        let auxTimeHours = Math.floor(operatorDetails.auxModeTimeToSec / 3600);
                        let auxTimeMinutes = Math.floor((operatorDetails.auxModeTimeToSec - (auxTimeHours * 3600)) / 60);
                        let auxTimeSeconds = operatorDetails.auxModeTimeToSec - (auxTimeHours * 3600) - (auxTimeMinutes * 60);

                        if (auxTimeHours < 10) {
                            auxTimeHours = "0" + auxTimeHours;
                        }
                        if (auxTimeMinutes < 10) {
                            auxTimeMinutes = "0" + auxTimeMinutes;
                        }
                        if (auxTimeSeconds < 10) {
                            auxTimeSeconds = "0" + auxTimeSeconds;
                        }
                        operatorDetails.auxModeTime = `${auxTimeHours}:${auxTimeMinutes}:${auxTimeSeconds}`;

                        // alert(operatorDetails.auxModeTimeToSec)
                        setOperatorDetails(operatorDetails);
                        setUpdate(new Date().toString());
                    }
                }
            }
        }, 5000);
        return () => clearInterval(interval);
    }, [userLoginStatus, operatorDetails])

    // When a teller login or logout, this effect will work. This will call the getAllOperatorsLoggedInBranch function and
    // update the list of users who are login and logged out today.
    useEffect(() => {
        if (showOperatorStatusDetails === false) return;

        if (messageInc9999 !== '') {
            // alert("3 9999")
            getAllOperatorsLoggedInBranch();
        }
    }, [messageInc9999]);

    useEffect(() => {
        if (messageInc9998 !== '') {
            getOperatorDataById(selectedUser);
        }
    }, [messageInc9998])



    // When a token is served or direct assiging a token, this effect will work. This will call the getOperatorDataById and get user 
    // data by user id. selectedUser is determine which user is selected now. At very first time, selectedUser is first user's id. 
    // If select a user, that user's id is set to selectedUser state.
    useEffect(() => {
        if (showOperatorStatusDetails === false) return;

        if (messageInc1001 !== ''
            || messageInc1002 !== ''
            || messageInc2000 !== ''
            || messageInc2001 !== ''
            || messageInc3000 !== ''
            || messageInc3001 !== '') {
            if (selectedUser !== null) {
                // alert("4 1001 1002")
                getOperatorDataById(selectedUser);
            }
        }
    }, [messageInc1001, messageInc1002,
        messageInc2000, messageInc2001,
        messageInc3000, messageInc3001]);


    // When select a user, this effect will work. Using this state, getOperatorDataById function can find the selected user's data  
    useEffect(() => {
        if (selectedUser !== null) {
            // alert("5 selectedUser")
            getOperatorDataById(selectedUser);
        }
    }, [selectedUser]);

    // Update the chart value.
    useEffect(() => {
        setChartValue(chartValue + 1);
    }, [])

    //getAllOperatorsLoggedInBranch - function
    const getAllOperatorsLoggedInBranch = () => {
        axios({
            method: 'GET',
            url: `${baseUrl}/real-time/operators-logged-in/branch/${selectedBranchId}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {
            let data = res.data.data;

            // alert("6")

            // Set login and logged-out operators data
            setOperatorsList(data);

            // This is use to filter online and offline users.
            setInitialOperatorsList(data);

            setFilterStatus(0);

            // Check messageInc9999. Because, if it is not, while the user login-logout(9999) this function will work and
            // set first user for selectedUser state. Then the useEffect which is took the selectedUser as a parameter will work.
            // That useEffect will run the getOperatorDataById function which is not necessary to run at this time(9999). 
            if (data !== null && data.length !== 0 && messageInc9999 === '') {
                setSelectedUser(data[0].userId);
            }

        }).catch((error) => {
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }

    const formatSecondsToHHMMSS = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600)
            .toString()
            .padStart(2, '0');
        const minutes = Math.floor((totalSeconds % 3600) / 60)
            .toString()
            .padStart(2, '0');
        const seconds = (totalSeconds % 60)
            .toString()
            .padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };

    //todo - operation login id is not need
    const getOperatorDataById = (userId) => {
        if (userId !== null) {
            axios({
                method: 'GET',
                url: `${baseUrl}/operator-login/operator-details/user/${userId}/branch/${selectedBranchId}`,
                headers: {
                    Authorization: token
                }
            }).then((res) => {
                // alert("7")
                let data = res.data.data;
                if (data.servingTimeToSec > data.servingTimeKpiToSec) {
                    setExeption(true);
                } else {
                    setExeption(false);
                }
                setOperatorDetails(data);
                setRatio(data.servicePercent);
                categoryServedPercentageLoop(data.catList);
                setuserLoginStatus(data.loginStatus);
                categoryServedCountLoop(data.hourlyServedView);
                setChartValue(chartValue + 1);
                setAllDataLoaded(true);
            }).catch((error) => {
                console.log(error);

                if (error.response !== undefined) {
                    toast.remove();
                    toast.error(error.response.data.message, {
                        position: 'bottom-center',
                    });
                } else {
                    toast.remove();
                    toast.error('Something went wrong', {
                        position: 'bottom-center',
                    });
                }

            })
        }
    }

    const categoryServedPercentageLoop = (categoryList) => {

        const category = [];
        const percentage = [];

        if (categoryList !== null) {
            categoryList.forEach(element => {
                category.push(element.category);
                percentage.push(element.percentage);
            })
        }

        setCategories(category);
        setPercentages(percentage);

    }

    const categoryServedCountLoop = (categoryList) => {

        const hourIntArray = [];
        const ticketCountArray = [];

        categoryList.forEach(element => {
            hourIntArray.push(element.hourRange);
            ticketCountArray.push(element.ticketCount);
        })

        setHourInt(hourIntArray);
        setTicketCount(ticketCountArray);
    }

    //onlineUsersLoop - function
    const onlineUsersLoop = (onlineUserList) => {
        console.log('onlineUsersLoop function start');

        const onlineUsers = [];

        onlineUserList.forEach(element => {

            if (element.loginStatus === 1 || element.loginStatus === 0 || element.loginStatus === 3) {
                onlineUsers.push(element);
            }

        })
        setFilterOnlineUsers(onlineUsers);
        setOperatorsList(onlineUsers);
    }

    //offlineUserLoop - function
    const offlineUserLoop = (offlineUserList) => {
        console.log('offlineUserLoop function start');

        const offlineUsers = [];

        offlineUserList.forEach(element => {

            if (element.loginStatus === 2 || element.loginStatus === -1) {
                offlineUsers.push(element);
            }
        })
        setFilterOfflineUsers(offlineUsers);
        setOperatorsList(offlineUsers);
    }

    useEffect(() => {
        if (filterStatus !== null) {
            if (filterStatus === 1) {
                if (searchKeyword !== null) {
                    const results = filterOnlineUsers.filter((operators) => {
                        return operators.operatorName.toString().toLowerCase().includes(searchKeyword.toLowerCase());
                    });
                    console.log("resu: ", results);
                    setOperatorsList(results);
                } else {
                    setOperatorsList(filterOnlineUsers);
                }
                setSearchText(searchKeyword);
            } else if (filterStatus === 2) {
                if (searchKeyword !== null) {
                    const results = filterOfflineUsers.filter((operators) => {
                        return operators.operatorName.toString().toLowerCase().includes(searchKeyword.toLowerCase());
                    });
                    console.log("resu: ", results);
                    setOperatorsList(results);
                } else {
                    setOperatorsList(filterOfflineUsers);
                }
                setSearchText(searchKeyword);
            }
        }

    }, [filterStatus])

    const forSearch = (e) => {
        const keyword = e.target.value;
        if (filterStatus !== null) {
            if (filterStatus === 1) {
                if (keyword !== '') {
                    const results = filterOnlineUsers.filter((operators) => {
                        return operators.operatorName.toString().toLowerCase().includes(keyword.toLowerCase());
                    });
                    setOperatorsList(results);
                } else {
                    setOperatorsList(filterOnlineUsers);
                }
                setSearchText(keyword);
            } else if (filterStatus === 2) {
                if (keyword !== '') {
                    const results = filterOfflineUsers.filter((operators) => {
                        return operators.operatorName.toString().toLowerCase().includes(keyword.toLowerCase());
                    });
                    setOperatorsList(results);
                } else {
                    setOperatorsList(filterOfflineUsers);
                }
                setSearchText(keyword);
            } else if (filterStatus === 0) {
                if (keyword !== '') {
                    const results = operatorsList.filter((operators) => {
                        return operators.operatorName.toString().toLowerCase().includes(keyword.toLowerCase());
                    });
                    setOperatorsList(results);
                } else {
                    setOperatorsList(initialOperatorsList);
                }
                setSearchText(keyword);
            }

            setSearchKeyword(keyword);
        }


    };

    const closeModal = () => {
        setSticky(true)
        setShowOperatorStatusDetails(false);
        messageInc9999 = '';
        messageInc1001 = '';
    }

    return (
        <>
            {showOperatorStatusDetails ?
                <div id="megamenu" className={`megamenu particles_js details-page open`}>
                    <span
                        onClick={() => {
                            closeModal()
                        }}
                        className="megamenu_toggle btn btn-danger"><i className="icon-close"></i></span>
                    {allDataLoaded === false ? (
                        //<ShimmerThumbnail>
                        <div className="container" style={{ width: '85%', height: '1500px', color: 'black', marginTop: '3%' }}></div>
                        //</ShimmerThumbnail>

                    ) : (<div className="container" style={{ marginTop: '3%' }}>
                        <div className="row clearfix ml-5" style={{ width: '85%' }}>
                            <div className="col-12">
                                <div className="card">
                                    <div className="body">
                                        <div style={{ textAlign: 'center' }}>
                                            <h4>Operator Status</h4>
                                            <small>{date}</small>
                                            <button className="btn btn-danger" style={{ float: 'right' }}
                                                onClick={() => {
                                                    closeModal();
                                                }}
                                            >Close</button>
                                        </div>

                                        <br></br>
                                        <div className='clearfix'></div>
                                        <Tab.Container id="left-tabs-example" defaultActiveKey="event0">
                                            <Row>
                                                <Col sm={3}>
                                                    <div className="input-group">
                                                        <input
                                                            value={searchtext}
                                                            onChange={forSearch}
                                                            type="text" className="form-control"
                                                            placeholder="Search here....." />

                                                        <div className="input-group-append">
                                                            <button className="btn btn-outline-secondary" type="button" >
                                                                <i className="fa fa-search" /></button>
                                                        </div>
                                                    </div>
                                                    <div className="row clearfix mt-2">

                                                        {/* {filterStatus === 1 ? (
                                                            <div className="col-md-3 col-sm-3 text-right">
                                                                <button className="btn btn-primary mb-2"
                                                                    type="button"
                                                                    title={`Online users`}
                                                                    onClick={() => {
                                                                        if (initialOperatorsList.length !== 0) {
                                                                            onlineUsersLoop(initialOperatorsList);
                                                                            setFilterStatus(1);
                                                                        }
                                                                    }}
                                                                >Online</button>
                                                            </div>
                                                        ) : (
                                                            <div className="col-md-3 col-sm-3 text-right">
                                                                <button className="btn btn-outline-primary mb-2"
                                                                    type="button"
                                                                    title={`Online users`}
                                                                    onClick={() => {
                                                                        if (initialOperatorsList.length !== 0) {
                                                                            onlineUsersLoop(initialOperatorsList);
                                                                            setFilterStatus(1);
                                                                        }
                                                                    }}
                                                                >Online</button>
                                                            </div>
                                                        )}

                                                        {filterStatus === 2 ? (
                                                            <div className="col-md-3 col-sm-3 text-right ml-2">
                                                                <button className="btn btn-secondary mb-2"
                                                                    type="button"
                                                                    title={`Offline users`}
                                                                    onClick={() => {
                                                                        if (initialOperatorsList.length !== 0) {
                                                                            offlineUserLoop(initialOperatorsList);
                                                                            setFilterStatus(2);
                                                                        }
                                                                    }}
                                                                >Offline</button>
                                                            </div>
                                                        ) : (
                                                            <div className="col-md-3 col-sm-3 text-right ml-2">
                                                                <button className="btn btn-outline-secondary mb-2"
                                                                    type="button"
                                                                    title={`Offline users`}
                                                                    onClick={() => {
                                                                        if (initialOperatorsList.length !== 0) {
                                                                            offlineUserLoop(initialOperatorsList);
                                                                            setFilterStatus(2);
                                                                        }
                                                                    }}
                                                                >Offline</button>
                                                            </div>
                                                        )} */}

                                                        <div className="col-md-3 col-sm-3">
                                                            {/* <button className="btn btn-sm btn-primary mb-2"
                                                                type="button"
                                                                // title={`Offline users`}
                                                                onClick={() => {
                                                                    getAllOperatorsLoggedInBranch();
                                                                    setFilterStatus(0);
                                                                }}

                                                            ><i className="fa fa-filter"></i>
                                                            </button> */}
                                                            <UncontrolledDropdown>
                                                                <DropdownToggle
                                                                    type="button"
                                                                    className="btn btn-sm btn-primary mb-2"
                                                                    data-toggle="tooltip"
                                                                    data-placement="top"
                                                                >
                                                                    <i className="fa fa-filter" aria-hidden="true"></i>
                                                                </DropdownToggle>

                                                                <DropdownMenu positionFixed={true} className="dropdown-menu-xs">
                                                                    <ul className="link-list-operator">
                                                                        <li>
                                                                            <DropdownItem
                                                                                tag="a"
                                                                                href="javascript:void(0);"
                                                                                className={filterStatus === 1 ? 'table-action-btn-option-disable' : ''}
                                                                                onClick={() => {
                                                                                    if (initialOperatorsList.length !== 0) {
                                                                                        onlineUsersLoop(initialOperatorsList);
                                                                                        setFilterStatus(1);
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <i className="fa fa-circle float-right text-success mr-1" title="Online" data-toggle="tooltip" data-placement="top"></i>
                                                                                <span>Online</span>
                                                                            </DropdownItem>
                                                                        </li>
                                                                        <li>
                                                                            <DropdownItem
                                                                                tag="a"
                                                                                href="javascript:void(0);"
                                                                                className={filterStatus === 2 ? 'table-action-btn-option-disable' : ''}
                                                                                onClick={() => {
                                                                                    if (initialOperatorsList.length !== 0) {
                                                                                        offlineUserLoop(initialOperatorsList);
                                                                                        setFilterStatus(2);
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <i className="fa fa-circle-o float-right text-success mr-1" title="Online" data-toggle="tooltip" data-placement="top"></i>
                                                                                <span>Offline</span>
                                                                            </DropdownItem>
                                                                        </li>
                                                                        <li>
                                                                            <DropdownItem
                                                                                tag="a"
                                                                                href="javascript:void(0);"
                                                                                className={filterStatus === 0 ? 'table-action-btn-option-disable' : ''}
                                                                                onClick={() => {
                                                                                    getAllOperatorsLoggedInBranch();
                                                                                    setFilterStatus(0);
                                                                                }}
                                                                            >
                                                                                <i className="fa fa-circle float-right text-secondary mr-1" title="Online" data-toggle="tooltip" data-placement="top"></i>
                                                                                <span>Reset</span>
                                                                            </DropdownItem>
                                                                        </li>
                                                                    </ul>
                                                                </DropdownMenu>
                                                            </UncontrolledDropdown>
                                                        </div>
                                                    </div>

                                                    {/* <Nav variant="pills" className="flex-column">
                                                        {
                                                            operatorsList.map((data, i) =>
                                                                <>
                                                                    <Nav.Item key={i}>
                                                                        {data.loginStatus === 1 || data.loginStatus === 0 || data.loginStatus === 3 ? (
                                                                            <Nav.Link eventKey={`event${i}`}
                                                                                className="operator_wizard_tab mb-1"
                                                                                onSelect={() => {
                                                                                    // getOperatorDataByOperationLoginId(data.operatorLoginId);
                                                                                    getOperatorDataById(data.userId);
                                                                                    // setSelectedOperator(data.operatorLoginId);
                                                                                    setSelectedUser(data.userId);
                                                                                }}

                                                                            >{data.operatorName}
                                                                                <i className="fa fa-circle float-right mt-1 text-success" title="Online" data-toggle="tooltip" data-placement="top"></i>
                                                                            </Nav.Link>
                                                                        ) : (
                                                                            <>
                                                                                {data.loginStatus === -1 ? (
                                                                                    <Nav.Link eventKey={`event${i}`}
                                                                                        className="operator_wizard_tab mb-1"
                                                                                        onSelect={() => {
                                                                                            getOperatorDataById(data.userId);
                                                                                            setSelectedUser(data.userId)
                                                                                        }}>{data.operatorName}
                                                                                        <>
                                                                                            <i className="fa fa-sign-out float-right logout-icon" title="Forced logout" data-toggle="tooltip" data-placement="top"></i>
                                                                                            <i className="fa fa-circle-o float-right mt-1 text-warning"></i>
                                                                                        </>
                                                                                    </Nav.Link>
                                                                                ) : (
                                                                                    <Nav.Link eventKey={`event${i}`}
                                                                                        className="operator_wizard_tab mb-1"
                                                                                        onSelect={() => {
                                                                                            getOperatorDataById(data.userId);
                                                                                            setSelectedUser(data.userId)
                                                                                        }}>{data.operatorName}
                                                                                        <i className="fa fa-circle-o float-right mt-1 text-warning" title="Offline" data-toggle="tooltip" data-placement="top"></i>
                                                                                    </Nav.Link>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </Nav.Item>
                                                                </>
                                                            )
                                                        }
                                                    </Nav> */}
                                                    <div className="scrollable-list">
                                                        {operatorsList.map((customer, index) => (
                                                            <div key={index} className="list-item">
                                                                <span className="customer-name">{customer.loginStatus === 2 ? <i className="fa fa-circle-o text-success"></i> : <i className="fa fa-circle text-success"></i>} {customer.operatorName}</span>
                                                                <button className={selectedUser === customer.userId ? "btn btn-sm btn-primary" : "btn btn-sm btn-outline-primary"}
                                                                    onClick={() => {
                                                                        // getOperatorDataByOperationLoginId(data.operatorLoginId);
                                                                        getOperatorDataById(customer.userId);
                                                                        // setSelectedOperator(data.operatorLoginId);
                                                                        setSelectedUser(customer.userId);
                                                                    }}
                                                                >
                                                                    {selectedUser === customer.userId ? <i className='fa fa-check-square'></i> : <i className='fa fa-check-square-o'></i>}

                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>

                                                </Col>

                                                <Col sm={9}>
                                                    <Tab.Content>
                                                        <div className="row clearfix">
                                                            <div className="col-lg-6 col-md-12">
                                                                <div className="card">
                                                                    <div className="body">
                                                                        <div>{operatorDetails.branchName}</div>
                                                                        <span
                                                                            className="badge mt-2"
                                                                            style={{
                                                                                backgroundColor: '#6576ff',
                                                                                color: '#fff',
                                                                                padding: '4px 10px',
                                                                                borderRadius: '20px',
                                                                                fontSize: '13px',
                                                                            }}
                                                                        >
                                                                            {operatorDetails.counter}
                                                                        </span>
                                                                        {/* <div className="py-4 m-0 text-center h1 text-success">$9,452</div>
                                                                        <div className="d-flex">
                                                                            <small className="text-muted">Previous Month</small>
                                                                            <div className="ml-auto"><i className="fa fa-caret-up text-success"></i>4.00%</div>
                                                                        </div> */}
                                                                        <div className="mt-4">
                                                                            {/* Removed text-center and margin:auto to keep image left-aligned */}
                                                                            <div style={{ width: '150px', height: '150px', position: 'relative' }}>
                                                                                <img
                                                                                    src={operatorDetails.imagePath || require('../../../assets/images/others/no-profile.jpg')}
                                                                                    alt="teller"
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        height: '100%',
                                                                                        objectFit: 'cover',
                                                                                        borderRadius: '10px',
                                                                                        border: '2px solid #fff'
                                                                                    }}
                                                                                />
                                                                                {operatorDetails.logoutTime === null ? (
                                                                                    operatorDetails.loginStatus === 3 ? (
                                                                                        <span className="badge badge-success image-badge-mattercode">
                                                                                            {operatorDetails.matterCode}
                                                                                        </span>
                                                                                    ) : (
                                                                                        <span className="badge badge-success image-badge-online">
                                                                                            Online
                                                                                        </span>
                                                                                    )
                                                                                ) : (
                                                                                    <span className="badge badge-success image-badge-offline">
                                                                                        Offline
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className='operator-times'>
                                                                            {operatorDetails.logoutTime === null ? (
                                                                                operatorDetails.loginStatus === 3 ? (
                                                                                    <p>{operatorDetails.auxModeTimeToSec >= operatorDetails.kpiSec / 2 &&
                                                                                        operatorDetails.auxModeTimeToSec <= (operatorDetails.kpiSec * 3) / 4 ? (
                                                                                        <>
                                                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                                <span className="text-green now-serving-blink">{operatorDetails.auxModeTime}</span>
                                                                                                &nbsp;/&nbsp;
                                                                                                <small>{operatorDetails.matterCodeTime} (AUX time)</small>
                                                                                            </div>
                                                                                        </>
                                                                                    ) : operatorDetails.auxModeTimeToSec >= (operatorDetails.kpiSec * 3) / 4 &&
                                                                                        operatorDetails.auxModeTimeToSec <= operatorDetails.kpiSec ? (
                                                                                        <>
                                                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                                <span className="text-warning now-serving-blink">⚠️{operatorDetails.auxModeTime}</span>
                                                                                                &nbsp;/&nbsp;
                                                                                                <small>{operatorDetails.matterCodeTime} (AUX time)</small>
                                                                                            </div>
                                                                                        </>
                                                                                    ) : operatorDetails.auxModeTimeToSec >= operatorDetails.kpiSec ? (
                                                                                        <>
                                                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                                <span className="text-danger now-serving-blink">{operatorDetails.auxModeTime}</span>
                                                                                                &nbsp;/&nbsp;
                                                                                                <small>{operatorDetails.matterCodeTime} (AUX time)</small>
                                                                                            </div>
                                                                                        </>
                                                                                    ) : (
                                                                                        <small>{operatorDetails.auxModeTime}</small>
                                                                                    )}
                                                                                    </p>
                                                                                ) : (
                                                                                    <p>Since: <span className="font-15">{operatorDetails.loggedTime}</span> <i className="fa fa-circle text-success"></i></p>
                                                                                )
                                                                            ) : (
                                                                                <span className="text-warning font-15">{operatorDetails.offlineStatus}</span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="card">
                                                                    <div className="body">
                                                                        <div>Total Completed Transactions</div>
                                                                        {operatorDetails.transactionCount < 10 ? (
                                                                            <div className="py-4 m-0 text-center h1">0{operatorDetails.transactionCount}</div>
                                                                        ) : (
                                                                            <div className="py-4 m-0 text-center h1">{operatorDetails.transactionCount}</div>
                                                                        )}
                                                                        {/* <div className="d-flex">
                                                                            <small className="text-muted">Previous Month</small>
                                                                            <div className="ml-auto">0.67%</div>
                                                                        </div> */}
                                                                    </div>
                                                                </div>
                                                                <div className="card">
                                                                    <div className="body top_counter">
                                                                        <div className="icon bg-primary text-white"><i className="fa fa-check-circle"></i> </div>
                                                                        <div className="content">
                                                                            <span>Total Completed Tickets</span>
                                                                            {operatorDetails.ticketCount < 10 ? (
                                                                                <h5 className="number mb-0">0{operatorDetails.ticketCount}</h5>
                                                                            ) : (
                                                                                <h5 className="number mb-0">{operatorDetails.ticketCount}</h5>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 col-md-12">
                                                                <div className="card">
                                                                    <div className="body">
                                                                        <div>Category-wise served ticket percentages</div>
                                                                        {categories.length !== 0 && percentages.length !== 0 && chartValue > 0 ? (
                                                                            <ServingCategoriesDonutFull
                                                                                categories={categories}
                                                                                percentages={percentages}
                                                                                chartValue={chartValue}
                                                                            />
                                                                        ) : null}
                                                                    </div>
                                                                </div>
                                                                <div className="card">
                                                                    <div className={`body now-serving-padding ${operatorDetails.loginStatus === 1 ? "bg-secondary" : ""}`}>
                                                                        <div className="content">
                                                                            <span> Now Serving</span>
                                                                            {operatorDetails.loginStatus === 1 ? (
                                                                                <div className="card-hover-wrapper"
                                                                                    onMouseEnter={() => setShowHoverModal(true)}
                                                                                    onMouseLeave={() => setShowHoverModal(false)}
                                                                                    style={{ position: 'relative' }}
                                                                                >
                                                                                    <h3 className="number mb-0 card-hover-wrapper">{operatorDetails.nowServingToken} {exeption ?
                                                                                        (<small className='now-serving-blink text-danger' style={{ fontSize: '20px' }}>{operatorDetails.servingTime}</small>)
                                                                                        : (<small className='now-serving-blink text-success' style={{ fontSize: '20px' }}>{operatorDetails.servingTime}</small>)}</h3>
                                                                                    {showHoverModal && (
                                                                                        <div className="hover-modal">
                                                                                            <div className="hover-modal-header">{operatorDetails.nowServingToken} Token Details</div>
                                                                                            <div className="hover-modal-body">
                                                                                                <p>Serving KPI: <span className='text-success'>{formatSecondsToHHMMSS(operatorDetails.servingTimeKpiToSec)}</span></p>
                                                                                                <p>Status: {exeption ? '⚠️ Exception' : '✅ Normal'}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            ) : operatorDetails.loginStatus === 0 ? (
                                                                                <h3 className="number mb-0 text-warning"> Idle </h3>
                                                                            ) : <h3 className="number mb-0"> -- </h3>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="card">
                                                                    <div className="body top_counter">
                                                                        <div className="icon bg-success text-white"><i className="fa fa-laptop"></i> </div>
                                                                        <div className="content">
                                                                            <span>Total Service Time</span>
                                                                            <h5 className="number mb-0">{operatorDetails.serviceTime}</h5>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="card">
                                                                    <div className="body top_counter">
                                                                        <div className="icon bg-warning text-white"><i className="fa fa-spinner"></i> </div>
                                                                        <div className="content">
                                                                            <span>Idle Time</span>
                                                                            <h5 className="number mb-0">{operatorDetails.idleTime}</h5>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* <div className="col-lg-12 col-md-12">
                                                                <div className="card">
                                                                    <div className="body top_counter">
                                                                        {hourInt.length !== 0 && ticketCount.length !== 0 && chartValue > 0 ?
                                                                            (<OperatorStatusCount hourInt={hourInt} ticketCount={ticketCount} chartValue={chartValue} />)
                                                                            :
                                                                            (null)}
                                                                        <small><b>Hourly served tickets count.</b></small>
                                                                    </div>
                                                                </div>

                                                            </div> */}
                                                        </div>



                                                        <div className='counter-status-right'>
                                                            <div className="row clearfix text-center">
                                                                <div className="col-6">
                                                                    {hourInt.length !== 0 && ticketCount.length !== 0 && chartValue > 0 ?
                                                                        (<OperatorStatusCount hourInt={hourInt} ticketCount={ticketCount} chartValue={chartValue} />)
                                                                        :
                                                                        (null)}
                                                                    <small><b>Hourly served tickets count.</b></small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Tab.Content>
                                                </Col>
                                            </Row>
                                        </Tab.Container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)}
                    <div id="particles-js"></div>
                </div>
                : null}
        </>
    );
}


export default OperatorStatusDetails;